// --- Neighbors map (Яндекс.Карты) ---
const buildNeighborIcon = (isActive = true) => {
  const width = 48;
  const height = Math.round(width * (100 / 75));
  const strokeColor = '#CEDA42';
  
  let svg;
  if (isActive) {
    // Активный маркер: заливка #CEDA42, белый конь
    svg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 75 100" fill="none">
        <path d="M75 32.6683C75 50.7106 37.5 100 37.5 100C37.5 100 0 50.7106 0 32.6683C0 14.6261 16.7893 0 37.5 0C58.2107 0 75 14.6261 75 32.6683Z" fill="${strokeColor}"/>
        <path d="M54.7404 21.6796L60.8937 35.9358C61.5989 37.5695 61.1022 39.3727 59.675 40.3604L57.8142 41.6481C56.3957 42.6297 54.3956 42.5716 52.8958 41.5052L42.569 34.1624C41.49 33.3993 39.857 34.4925 40.5548 35.5747L48.2246 48.6703C49.7404 51.2586 47.9437 54.2632 44.8947 54.2387L26.0385 54.0874C24.0411 54.0714 22.247 52.7037 21.7854 50.8451L18.0901 35.9668C17.1725 32.2653 17.8658 28.3769 20.0428 25.0152C22.2198 21.6535 25.7344 19.0441 29.9415 17.6658L46.074 12.3813C47.7425 11.8348 49.485 13.373 49.0237 14.9854C48.6692 16.2247 49.6723 17.5199 50.9671 18.0767C52.6597 18.8045 54.0345 20.0441 54.7404 21.6796Z" fill="white"/>
      </svg>
    `;
  } else {
    // Неактивный маркер: белый фон, обводка #CEDA42 2px, конь закрашен #CEDA42
    svg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 75 100" fill="none">
        <path d="M75 32.6683C75 50.7106 37.5 100 37.5 100C37.5 100 0 50.7106 0 32.6683C0 14.6261 16.7893 0 37.5 0C58.2107 0 75 14.6261 75 32.6683Z" fill="white" stroke="${strokeColor}" stroke-width="2"/>
        <path d="M54.7404 21.6796L60.8937 35.9358C61.5989 37.5695 61.1022 39.3727 59.675 40.3604L57.8142 41.6481C56.3957 42.6297 54.3956 42.5716 52.8958 41.5052L42.569 34.1624C41.49 33.3993 39.857 34.4925 40.5548 35.5747L48.2246 48.6703C49.7404 51.2586 47.9437 54.2632 44.8947 54.2387L26.0385 54.0874C24.0411 54.0714 22.247 52.7037 21.7854 50.8451L18.0901 35.9668C17.1725 32.2653 17.8658 28.3769 20.0428 25.0152C22.2198 21.6535 25.7344 19.0441 29.9415 17.6658L46.074 12.3813C47.7425 11.8348 49.485 13.373 49.0237 14.9854C48.6692 16.2247 49.6723 17.5199 50.9671 18.0767C52.6597 18.8045 54.0345 20.0441 54.7404 21.6796Z" fill="${strokeColor}"/>
      </svg>
    `;
  }
  
  return {
    svg,
    width,
    height,
  };
};

const parseNeighborsData = () => {
  const dataNode = document.getElementById('neighbors-map-data');
  if (!dataNode || !dataNode.textContent) {
    return [];
  }
  try {
    const parsed = JSON.parse(dataNode.textContent);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    console.warn('Neighbors map data parse error', e);
    return [];
  }
};

// Нормализует pointId - декодирует URL-encoded строку
const normalizePointId = (id) => {
  if (!id) return id;
  try {
    return decodeURIComponent(id);
  } catch (e) {
    return id;
  }
};

const mountNeighborsMap = () => {
  const mapEl = document.getElementById('neighbors-map');
  if (!mapEl) {
    return;
  }

  const points = parseNeighborsData();
  if (!points.length) {
    return;
  }

  const center = mapEl.dataset.center
    ? mapEl.dataset.center.split(',').map((num) => parseFloat(num.trim()))
    : [55.7558, 37.6173];
  const zoom = parseInt(mapEl.dataset.zoom || '11', 10);

  const state = {
    activeId: normalizePointId(points[0]?.id) || null,
    openedId: normalizePointId(points[0]?.id) || null,
  };
  const placemarks = new Map();
  const markerLayouts = new Map(); // Сохраняем ссылки на layout
  const placemarksByPointId = new Map(); // Сохраняем placemarks по pointId для доступа из layout
  const iconActive = buildNeighborIcon(true);
  const iconInactive = buildNeighborIcon(false);
  const iconWidth = iconActive.width;
  const iconHeight = iconActive.height;
  
  const markerLayout = ymaps.templateLayoutFactory.createClass(
    `<div class="neighbors-marker" data-point-id="$[properties.pointId]">
      ${iconInactive.svg}
    </div>`,
    {
      build() {
        markerLayout.superclass.build.call(this);
        const rawPointId = this.getData().properties.get('pointId');
        const pointId = normalizePointId(rawPointId);
        const el = this.getElement();
        const markerEl = el ? el.querySelector('.neighbors-marker') || el : null;
        if (markerEl && pointId) {
          markerEl.dataset.pointId = pointId;
          markerLayouts.set(pointId, this);
        }
        this._optionChangeHandler = () => {
          const rawPointId = this.getData().properties.get('pointId');
          const pointId = normalizePointId(rawPointId);
          if (pointId) {
            const pm = placemarksByPointId.get(pointId);
            if (pm) {
              const isActive = pm.options.get('isActive', false);
              this._applyState(isActive);
              return;
            }
          }
          const isActive = this.getData().options.get('isActive', false);
          this._applyState(isActive);
        };
        this.getData().options.events.add('change', this._optionChangeHandler);
        const initialIsActive = this.getData().options.get('isActive', false);
        this._applyState(initialIsActive);
      },
      getOffset() {
        return [-iconWidth / 2, -iconHeight];
      },
      _applyState(isActiveValue) {
        const el = this.getElement();
        if (!el) {
          return;
        }
        const markerEl = el.querySelector('.neighbors-marker') || el;
        const isActive = isActiveValue !== undefined ? isActiveValue : this.getData().options.get('isActive', false);
        markerEl.classList.toggle('is-active', !!isActive);
        
        // Обновляем SVG в зависимости от состояния
        const svgEl = markerEl.querySelector('svg');
        if (svgEl) {
          const newIcon = isActive ? iconActive : iconInactive;
          svgEl.outerHTML = newIcon.svg;
        }
      },
      onSublayoutSizeChange() {
        markerLayout.superclass.onSublayoutSizeChange.call(this);
        const rawPointId = this.getData().properties.get('pointId');
        const pointId = normalizePointId(rawPointId);
        if (pointId) {
          const pm = placemarksByPointId.get(pointId);
          if (pm) {
            const isActive = pm.options.get('isActive', false);
            this._applyState(isActive);
            return;
          }
        }
        const isActive = this.getData().options.get('isActive', false);
        this._applyState(isActive);
      },
      onAfterRebuild() {
        markerLayout.superclass.onAfterRebuild.call(this);
        const rawPointId = this.getData().properties.get('pointId');
        const pointId = normalizePointId(rawPointId);
        if (pointId) {
          const pm = placemarksByPointId.get(pointId);
          if (pm) {
            const isActive = pm.options.get('isActive', false);
            this._applyState(isActive);
            return;
          }
        }
        const isActive = this.getData().options.get('isActive', false);
        this._applyState(isActive);
      },
      clear() {
        const rawPointId = this.getData().properties.get('pointId');
        const pointId = normalizePointId(rawPointId);
        if (pointId) {
          markerLayouts.delete(pointId);
        }
        if (this._optionChangeHandler) {
          this.getData().options.events.remove('change', this._optionChangeHandler);
        }
        markerLayout.superclass.clear.call(this);
      },
    }
  );

  const map = new ymaps.Map(
    mapEl,
    {
      center,
      zoom,
      controls: ['zoomControl'],
    },
    {
      suppressMapOpenBlock: true,
    }
  );

  const syncMarkers = () => {
    const normalizedActiveId = normalizePointId(state.activeId);
    placemarks.forEach((pm, id) => {
      const normalizedId = normalizePointId(id);
      const isActive = normalizedId === normalizedActiveId;
      pm.options.set('isActive', isActive);
      pm.options.set('zIndex', isActive ? 300 : 200);
      pm.options.set('zIndexActive', isActive ? 320 : 220);

      const layout = markerLayouts.get(normalizedId);
      if (layout && layout._applyState) {
        layout._applyState(isActive);
      } else {
        const mapContainer = map.container.getElement();
        if (mapContainer) {
          const markerEl = mapContainer.querySelector(`.neighbors-marker[data-point-id="${normalizedId}"]`);
          if (markerEl) {
            markerEl.classList.toggle('is-active', isActive);
          }
        }
      }
    });
  };

  const cards = Array.from(document.querySelectorAll('.neighbors-card'));

  const gallerySliders = new Map(); // Сохраняем ссылки на слайдеры

  const initGallerySlider = (card) => {
    const rawId = card.dataset.pointId;
    const id = normalizePointId(rawId);
    if (gallerySliders.has(id)) {
      return;
    }

    const galleryEl = card.querySelector('.neighbors-card__gallery');
    const gallerySliderEl = card.querySelector('.neighbors-card__gallery-slider');
    if (!gallerySliderEl || typeof Swiper === 'undefined') {
      return;
    }

    const slides = gallerySliderEl.querySelectorAll('.swiper-slide');
    const slidesCount = slides.length;
    
    // Если слайдов 3 или меньше, не инициализируем слайдер
    if (slidesCount <= 3) {
      if (galleryEl) {
        galleryEl.classList.add('no-slider');
      }
      return;
    }

    const prevButton = galleryEl.querySelector('.neighbors-card__gallery-button--prev');
    const nextButton = galleryEl.querySelector('.neighbors-card__gallery-button--next');
    const paginationEl = gallerySliderEl.querySelector('.neighbors-card__gallery-pagination');
    
    // Loop работает только если слайдов достаточно (минимум slidesPerView * 2)
    const enableLoop = slidesCount >= 6;

    const swiperConfig = {
      slidesPerView: 3,
      slidesPerGroup: 1,
      spaceBetween: 8,
      loop: enableLoop,
      speed: 600,
      autoplay: false,
      effect: 'slide',
      watchSlidesProgress: true,
      watchOverflow: false,
      allowTouchMove: true,
      observer: true,
      observeParents: true,
      watchSlidesVisibility: true,
      pagination: paginationEl ? {
        el: paginationEl,
        clickable: true,
        dynamicBullets: true,
      } : false,
    };

    if (prevButton && nextButton) {
      swiperConfig.navigation = {
        nextEl: nextButton,
        prevEl: prevButton,
        disabledClass: 'swiper-button-disabled',
      };
    }

    const swiper = new Swiper(gallerySliderEl, swiperConfig);

    // Обновляем Swiper после инициализации
    swiper.on('init', () => {
      swiper.update();
    });

    // Обновляем Swiper после небольшой задержки для правильного расчета размеров
    setTimeout(() => {
      swiper.update();
    }, 100);

    gallerySliders.set(id, swiper);
  };

  // Создаем один общий lightbox для всех галерей
  let lightbox = null;
  let currentImageArray = [];
  let currentIndex = 0;

  const initLightbox = () => {
    if (lightbox) {
      return;
    }

    lightbox = document.createElement('div');
    lightbox.id = 'neighbors-gallery-lightbox';
    lightbox.className = 'neighbors-gallery-lightbox';
    lightbox.innerHTML = `
      <div class="neighbors-gallery-lightbox__overlay"></div>
      <div class="neighbors-gallery-lightbox__content">
        <button class="neighbors-gallery-lightbox__close" aria-label="Закрыть">&times;</button>
        <button class="neighbors-gallery-lightbox__prev" aria-label="Предыдущее изображение">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="neighbors-gallery-lightbox__next" aria-label="Следующее изображение">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <img class="neighbors-gallery-lightbox__image" src="" alt="">
      </div>
    `;
    document.body.appendChild(lightbox);

    const overlay = lightbox.querySelector('.neighbors-gallery-lightbox__overlay');
    const closeBtn = lightbox.querySelector('.neighbors-gallery-lightbox__close');
    const prevBtn = lightbox.querySelector('.neighbors-gallery-lightbox__prev');
    const nextBtn = lightbox.querySelector('.neighbors-gallery-lightbox__next');
    const imageEl = lightbox.querySelector('.neighbors-gallery-lightbox__image');

    const openLightbox = (imageArray, index) => {
      currentImageArray = imageArray;
      currentIndex = index;
      const img = currentImageArray[currentIndex];
      if (img) {
        imageEl.src = img.src;
        imageEl.alt = img.alt || '';
        lightbox.classList.add('is-active');
        document.body.style.overflow = 'hidden';
        updateButtons();
      }
    };

    const closeLightbox = () => {
      lightbox.classList.remove('is-active');
      document.body.style.overflow = '';
    };

    const showNext = () => {
      if (currentIndex < currentImageArray.length - 1) {
        openLightbox(currentImageArray, currentIndex + 1);
      } else {
        openLightbox(currentImageArray, 0);
      }
    };

    const showPrev = () => {
      if (currentIndex > 0) {
        openLightbox(currentImageArray, currentIndex - 1);
      } else {
        openLightbox(currentImageArray, currentImageArray.length - 1);
      }
    };

    const updateButtons = () => {
      if (currentImageArray.length <= 1) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
      } else {
        prevBtn.style.display = 'flex';
        nextBtn.style.display = 'flex';
      }
    };

    overlay.addEventListener('click', closeLightbox);
    closeBtn.addEventListener('click', closeLightbox);
    nextBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      showNext();
    });
    prevBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      showPrev();
    });

    // Закрытие по Escape и навигация стрелками
    document.addEventListener('keydown', (e) => {
      if (lightbox.classList.contains('is-active')) {
        if (e.key === 'Escape') {
          closeLightbox();
        } else if (e.key === 'ArrowLeft') {
          showPrev();
        } else if (e.key === 'ArrowRight') {
          showNext();
        }
      }
    });

    // Экспортируем функцию открытия
    window.openNeighborsLightbox = openLightbox;
  };

  const initGalleryLightbox = (card) => {
    const galleryEl = card.querySelector('.neighbors-card__gallery');
    if (!galleryEl) {
      return;
    }

    const images = galleryEl.querySelectorAll('.neighbors-card__gallery-slide img');
    if (!images.length) {
      return;
    }

    // Инициализируем lightbox один раз
    initLightbox();

    const imageArray = Array.from(images);

    // Добавляем обработчики кликов на изображения
    images.forEach((img, index) => {
      if (img.dataset.lightboxInitialized) {
        return;
      }
      img.dataset.lightboxInitialized = 'true';
      img.style.cursor = 'pointer';
      img.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (window.openNeighborsLightbox) {
          window.openNeighborsLightbox(imageArray, index);
        }
      });
    });
  };

  const scrollToCard = (card) => {
    const cardsContainer = card.closest('.neighbors-map__cards');
    if (!cardsContainer) {
      return;
    }

    // Ждем завершения анимации раскрытия карточки
    setTimeout(() => {
      const cardRect = card.getBoundingClientRect();
      const containerRect = cardsContainer.getBoundingClientRect();
      const containerScrollTop = cardsContainer.scrollTop;
      const originalMaxHeight = cardsContainer.dataset.originalMaxHeight || '520px';
      
      // Проверяем, полностью ли видна карточка
      const cardTop = cardRect.top - containerRect.top + containerScrollTop;
      const cardBottom = cardTop + cardRect.height;
      const containerHeight = cardsContainer.clientHeight;
      const containerScrollBottom = containerScrollTop + containerHeight;
      const cardHeight = cardRect.height;
      
      // Если карточка выше контейнера, временно увеличиваем max-height
      if (cardHeight > containerHeight) {
        const newMaxHeight = cardHeight + 60; // Добавляем отступ сверху и снизу
        cardsContainer.style.maxHeight = `${newMaxHeight}px`;
        cardsContainer.style.transition = 'max-height 0.3s ease';
      }
      
      // Если карточка не полностью видна, прокручиваем
      if (cardTop < containerScrollTop || cardBottom > containerScrollBottom) {
        // Вычисляем нужную позицию прокрутки (с небольшим отступом сверху)
        const scrollOffset = 20;
        const targetScrollTop = cardTop - scrollOffset;
        
        // Плавная прокрутка
        cardsContainer.scrollTo({
          top: Math.max(0, targetScrollTop),
          behavior: 'smooth'
        });
        
        // Проверяем позицию скролла после прокрутки
        setTimeout(() => {
          const scrollTop = cardsContainer.scrollTop;
          const scrollHeight = cardsContainer.scrollHeight;
          const clientHeight = cardsContainer.clientHeight;
          const isAtBottom = scrollTop + clientHeight >= scrollHeight - 5;
          
          if (isAtBottom) {
            cardsContainer.classList.add('is-scrolled-to-bottom');
          } else {
            cardsContainer.classList.remove('is-scrolled-to-bottom');
          }
        }, 600); // Ждем завершения плавной прокрутки
      }
    }, 300); // Ждем завершения CSS анимации
  };

  const syncCards = () => {
    const normalizedActiveId = normalizePointId(state.activeId);
    const normalizedOpenedId = normalizePointId(state.openedId);
    
    // Находим контейнер cards
    const cardsContainer = cards.length > 0 ? cards[0].closest('.neighbors-map__cards') : null;
    const originalMaxHeight = cardsContainer ? (cardsContainer.dataset.originalMaxHeight || getComputedStyle(cardsContainer).maxHeight) : null;
    
    // Сохраняем исходную высоту при первом вызове
    if (cardsContainer && !cardsContainer.dataset.originalMaxHeight) {
      cardsContainer.dataset.originalMaxHeight = getComputedStyle(cardsContainer).maxHeight;
    }
    
    cards.forEach((card) => {
      const rawId = card.dataset.pointId;
      const id = normalizePointId(rawId);
      const isActive = id === normalizedActiveId;
      const isOpened = id === normalizedOpenedId;
      const wasOpened = card.classList.contains('is-open');
      
      card.classList.toggle('is-active', isActive);
      card.classList.toggle('is-open', isOpened);
      card.setAttribute('aria-expanded', isOpened ? 'true' : 'false');

      if (isOpened) {
        setTimeout(() => {
          initGallerySlider(card);
          // Обновляем Swiper после открытия карточки
          const rawId = card.dataset.pointId;
          const id = normalizePointId(rawId);
          const swiper = gallerySliders.get(id);
          if (swiper) {
            setTimeout(() => {
              swiper.update();
            }, 250);
          }
        }, 150);
      }
      
      // Если карточка закрылась, возвращаем исходную высоту контейнера
      if (wasOpened && !isOpened && cardsContainer && originalMaxHeight) {
        setTimeout(() => {
          cardsContainer.style.maxHeight = originalMaxHeight;
          cardsContainer.style.transition = 'max-height 0.3s ease';
        }, 100);
      }
    });
  };

  const clearHover = () => {
    state.activeId = state.openedId;
    syncCards();
    syncMarkers();
  };

  const setActive = (id) => {
    const normalizedId = normalizePointId(id);
    state.activeId = normalizedId;
    syncCards();
    syncMarkers();
  };

  const setOpened = (id) => {
    const normalizedId = normalizePointId(id);
    state.activeId = normalizedId;
    state.openedId = normalizedId;
    syncCards();
    syncMarkers();
    
    // Прокручиваем к открытой карточке только при открытии
    const openedCard = cards.find(card => {
      const rawId = card.dataset.pointId;
      const cardId = normalizePointId(rawId);
      return cardId === normalizedId;
    });
    
    if (openedCard) {
      scrollToCard(openedCard);
    }
  };

  points.forEach((point) => {
    const normalizedId = normalizePointId(point.id);
    const pm = new ymaps.Placemark(
      point.coords,
      {
        hintContent: point.hint || point.title || '',
        balloonContent: '',
        pointId: normalizedId,
      },
      {
        iconLayout: markerLayout,
        isActive: normalizedId === state.activeId,
        iconShape: {
          type: 'Rectangle',
          coordinates: [
            [-iconWidth / 2, -iconHeight],
            [iconWidth / 2, 0],
          ],
        },
      }
    );

    pm.events.add('mouseenter', () => {
      setActive(normalizedId);
    });
    pm.events.add('mouseleave', () => {
      clearHover();
    });
    pm.events.add('click', () => {
      setOpened(normalizedId);
    });

    placemarks.set(normalizedId, pm);
    placemarksByPointId.set(normalizedId, pm);
    map.geoObjects.add(pm);
  });

  // Если точек больше одной — подстроим карту
  if (points.length > 1) {
    const bounds = ymaps.geoQuery(Array.from(placemarks.values())).getBounds();
    if (bounds) {
      map.setBounds(bounds, { checkZoomRange: true, zoomMargin: 40 });
    }
  }

  cards.forEach((card) => {
    const rawId = card.dataset.pointId;
    const id = normalizePointId(rawId);
    card.addEventListener('mouseenter', () => setActive(id));
    card.addEventListener('mouseleave', () => clearHover());
    card.addEventListener('click', (e) => {
      // Если клик по ссылке или кнопке, не перехватываем событие
      if (e.target.closest('a, button')) {
        return;
      }
      e.preventDefault();
      setOpened(id);
    });
    // Инициализируем lightbox для всех карточек
    initGalleryLightbox(card);
  });

  syncCards();
  
  // Функция для проверки, достиг ли пользователь конца скролла
  const checkScrollPosition = () => {
    const cardsContainer = cards.length > 0 ? cards[0].closest('.neighbors-map__cards') : null;
    if (!cardsContainer) {
      return;
    }
    
    const scrollTop = cardsContainer.scrollTop;
    const scrollHeight = cardsContainer.scrollHeight;
    const clientHeight = cardsContainer.clientHeight;
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - 5; // Небольшой отступ для точности
    
    if (isAtBottom) {
      cardsContainer.classList.add('is-scrolled-to-bottom');
    } else {
      cardsContainer.classList.remove('is-scrolled-to-bottom');
    }
  };
  
  // Добавляем обработчик скролла для контейнера карточек
  const cardsContainer = cards.length > 0 ? cards[0].closest('.neighbors-map__cards') : null;
  if (cardsContainer) {
    cardsContainer.addEventListener('scroll', checkScrollPosition);
    // Проверяем начальную позицию
    checkScrollPosition();
  }
  
  // Убираем класс is-loading после инициализации
  const removeLoadingState = () => {
    if (mapEl) {
      mapEl.classList.remove('is-loading');
    }
    if (cardsContainer) {
      cardsContainer.classList.remove('is-loading');
      // Проверяем позицию скролла после удаления loading состояния
      setTimeout(checkScrollPosition, 100);
    }
  };
  
  // Ждем, пока карта полностью загрузится и элементы появятся в DOM, затем синхронизируем
  map.events.add('idle', () => {
    setTimeout(() => {
      syncMarkers();
      removeLoadingState();
    }, 100);
  });
  setTimeout(() => {
    syncMarkers();
    removeLoadingState();
  }, 500);
};

const initNeighborsMap = () => {
  const mapEl = document.getElementById('neighbors-map');
  if (!mapEl) {
    return;
  }

  const waitForYmaps = () => {
    if (typeof ymaps === 'undefined') {
      setTimeout(waitForYmaps, 300);
      return;
    }
    ymaps.ready(mountNeighborsMap);
  };

  waitForYmaps();
};

export default initNeighborsMap;

